import { Component, OnInit } from '@angular/core';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css'],
})
export class PageNotFoundComponent implements OnInit {
  anwendungsname = ConstantsTexte.ANWENDUNGSNAME;

  constructor() {}

  ngOnInit(): void {
  }
}
